import { Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

type Props = {
  icon: SvgIconComponent;
  title: string;
  subtitle: string;
};

export default function EmptyState({ icon: Icon, title, subtitle }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', py: 8, gap: 1, color: 'text.disabled' }}>
      <Icon sx={{ fontSize: 56 }} />
      <Typography variant="h6" fontWeight={600} color="text.secondary">{title}</Typography>
      <Typography variant="body2" color="text.disabled">{subtitle}</Typography>
    </Box>
  );
}
